var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronLeftIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.025 19.012c-.284 0-.538-.094-.728-.284l-6.074-6.075a.976.976 0 0 1 0-1.424l6.074-6.075a.976.976 0 0 1 1.424 0 .976.976 0 0 1 0 1.424l-5.347 5.347 5.347 5.379a.976.976 0 0 1 0 1.424.982.982 0 0 1-.696.284"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronLeftIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-left-icon.3865176fa808dfac82c97155dc5ffd4d.svg";